
import { Utils } from "./utils";

export class ZEvents{

    eventOptions = { "trusted" : true, "bubbles" : true, "cancelable" : true };
    
    static loadCustomEvents(){
        Utils.getNS().appEvents = {}; 
    }

    static getCustomEvents(){
        return Utils.getNS().appEvents;
    }

    static getCustomEventName(eventGroup, eventEntryName){
        //console.log(this.getCustomEvents()[eventGroup][eventEntryName]);
        if( this.getCustomEvents()[eventGroup][eventEntryName] !== undefined ){
            return this.getCustomEvents()[eventGroup][eventEntryName].eventName;
        }
    }

    static triggerEvent(eventGroup, eventName, element = null){
        try{
            if( element == null ){
                document.dispatchEvent( this.getCustomEvents()[eventGroup][eventName].eventObj );
            }else{
                element.dispatchEvent( this.getCustomEvents()[eventGroup][eventName].eventObj );
            }
        }catch(e){
            console.log(`Error while triggering event, check that the event and corresponding group exists in ${Utils.getVarNS()}.appEvents`)
        }
    }

    static triggerEventOnElement(eventGroup, eventName, element){
        try{
            element.dispatchEvent( this.getCustomEvents()[eventGroup][eventName].eventObj );
        }catch(e){
            console.log(`Error while triggering event, check that the event and corresponding group exists in ${Utils.getVarNS()}.appEvents`)
        }
    }

    static addCustomEvent(eventGroup, eventEntryName, eventName){
        if( this.getCustomEvents()[eventGroup] == undefined ){
            this.getCustomEvents()[eventGroup] = {};
        }
        this.getCustomEvents()[eventGroup][eventEntryName] = {
            "eventName" : `${Utils.getVarNS()}.${eventName}`,
            "eventObj" : new CustomEvent(`${Utils.getVarNS()}.${eventName}`, this.eventOptions)
        };
    }

}